import { render } from "./TermDeposits.vue?vue&type=template&id=3625ba3a&scoped=true"
import script from "./TermDeposits.vue?vue&type=script&lang=js"
export * from "./TermDeposits.vue?vue&type=script&lang=js"

import "./TermDeposits.vue?vue&type=style&index=0&id=3625ba3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3625ba3a"]])

export default __exports__